import apiClient, { LONG_TIMEOUT } from '../api/client';
import { API_ENDPOINTS } from '../api/endpoints';

const financeService = {
    getSummary: async (companyId) => {
        const response = await apiClient.get(`${API_ENDPOINTS.FINANCE.BASE}/summary`, {
            params: { companyId }
        });
        return response.data;
    },
    getPayroll: async (companyId, month, year) => {
        const response = await apiClient.get(`${API_ENDPOINTS.FINANCE.BASE}/payroll`, {
            params: { companyId, month, year }
        });
        const data = response.data.data || response.data;
        return Array.isArray(data) ? data : [];
    },

    getAllLeaves: async () => {
        try {
            // Agar aapke endpoints file mein LEAVES.BASE: '/leaves' hai
            const response = await apiClient.get(API_ENDPOINTS.LEAVES.BASE);
            // NestJS aksar { data: [...] } bhejta hai, toh handle kar lo
            return response.data?.data || response.data;
        } catch (error) {
            console.error("Error in getAllLeaves Service:", error);
            throw error;
        }
    },

    updateLeaveStatus: async (leaveId, status, adminComment = "", reviewedByName = "Admin", deductDays = 1) => {
        try {
            if (!leaveId) throw new Error("Leave ID is missing!");

            const url = API_ENDPOINTS.LEAVES.UPDATE_STATUS(leaveId);

            console.log(" Calling API:", url);

            const response = await apiClient.patch(url, {
                status: status.toUpperCase(),
                adminComment,
                reviewedByName,
                deductDays: status.toUpperCase() === 'REJECTED' ? 2 : deductDays
            });

            return response.data;

        } catch (error) {
            console.error("❌ Service Error (404/500):", error.response?.data || error.message);
            throw error;
        }
    },

    getExpenses: async (companyId) => {
        const response = await apiClient.get(`${API_ENDPOINTS.FINANCE.BASE}/expenses`, {
            params: { companyId }
        });
        const data = response.data.data || response.data;
        return Array.isArray(data) ? data : [];
    },


    createExpense: async (data) => {
        const response = await apiClient.post(`${API_ENDPOINTS.FINANCE.BASE}/expenses`, data);
        return response.data;
    },

    updateExpense: async (expenseId, data) => {
        const response = await apiClient.patch(`${API_ENDPOINTS.FINANCE.BASE}/expenses/${expenseId}`, data);
        return response.data;
    },

    deleteExpense: async (expenseId) => {
        const response = await apiClient.delete(`${API_ENDPOINTS.FINANCE.BASE}/expenses/${expenseId}`);
        return response.data;
    },

    createPayroll: async (data) => {
        const response = await apiClient.post(
            `${API_ENDPOINTS.FINANCE.BASE}/payroll`,
            data
        );
        return response.data.data || response.data;
    },

    bulkGenerateRealPayroll: async (month, year, companyId, employeeId) => {
        const payload = { month, year };
        if (companyId) payload.companyId = companyId;
        if (employeeId) payload.employeeId = employeeId;
        const response = await apiClient.post(`${API_ENDPOINTS.FINANCE.BASE}/bulk-generate`, payload, { timeout: LONG_TIMEOUT });
        return response.data;
    },

    getEmployeePayrolls: async (employeeId) => {
        const res = await apiClient.get(`${API_ENDPOINTS.FINANCE.BASE}/payroll`, {
            params: { employeeId }
        });
        return res.data.data || res.data;
    },




    getPayrollById: async (id) => {
        const res = await apiClient.get(`${API_ENDPOINTS.FINANCE.BASE}/payroll/${id}`);
        return res.data?.data || res.data;
    },

    updatePayroll: async (id, data) => {
        const response = await apiClient.patch(`${API_ENDPOINTS.FINANCE.BASE}/payroll/${id}`, data);
        return response.data.data || response.data;
    },

    saveCustomHtml: async (id, customPayslipHtml, customEmailBodyHtml) => {
        const payload = { customPayslipHtml, customEmailBodyHtml };
        const response = await apiClient.put(`${API_ENDPOINTS.FINANCE.BASE}/payroll/${id}/custom-html`, payload);
        return response.data.data || response.data;
    },

    // Fetch the authoritative payslip PDF — the same configured format emailed to
    // the employee. Returns a Blob. Backend enforces owner/admin access.
    getPayslipPdf: async (id) => {
        const response = await apiClient.get(`${API_ENDPOINTS.FINANCE.BASE}/payroll/${id}/slip`, {
            responseType: 'blob',
            timeout: LONG_TIMEOUT, // server renders the PDF on demand
        });
        return response.data;
    },

    deletePayroll: async (id) => {
        const response = await apiClient.delete(`${API_ENDPOINTS.FINANCE.BASE}/payroll/${id}`);
        return response.data;
    },
    updateLeave: async (id, data) => {
        const response = await apiClient.patch(`${API_ENDPOINTS.LEAVES.BASE}/${id}`, data);
        return response.data;
    },
    deleteLeave: async (id) => {
        const response = await apiClient.delete(`${API_ENDPOINTS.LEAVES.BASE}/${id}`);
        return response.data;
    },
    sendPayrollEmail: async (id, payload) => {
        const response = await apiClient.post(`${API_ENDPOINTS.FINANCE.BASE}/payroll/${id}/send-email`, payload, { timeout: LONG_TIMEOUT });
        return response.data;
    },
};

export default financeService;
